import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-2 mb-3" }
const _hoisted_2 = { class: "grid grid-cols-4 gap-2 mb-3" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "flex justify-end pt-3" }
const _hoisted_6 = { class: "m-auto px-8 md:px-20 pb-8 pt-3" }
const _hoisted_7 = { class: "py-10 flex justify-between" }
const _hoisted_8 = { class: "bg-next-orange text-white p-3 mb-3 font-bold" }
const _hoisted_9 = { class: "m-auto" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "pb-5 text-2xl" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "grid grid-cols-12 gap-3 mb-5" }
const _hoisted_15 = { class: "border-b-next-atp border-b-2 text-next-atp mb-3" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "flex gap-3 mb-3" }
const _hoisted_18 = { class: "rotate-x-180 overflow-x-scroll mb-5 pb-3" }
const _hoisted_19 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalRigaPagamento = _resolveComponent("ModalRigaPagamento")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_CardDivisorioGrigio = _resolveComponent("CardDivisorioGrigio")!
  const _component_OffertaTable = _resolveComponent("OffertaTable")!
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_NextTable = _resolveComponent("NextTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Modal, {
        visible: _ctx.modal_oda_visible,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modal_oda_visible) = $event)),
        backdrop: ""
      }, {
        header: _withCtx(() => _cache[10] || (_cache[10] = [
          _createElementVNode("h2", { class: "text-xl font-bold mb-3" }, "Confermi di creare l'ordine di acquisto con le seguenti righe?", -1)
        ])),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "font-bold" }, "Descrizione", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "font-bold" }, "Valore", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "font-bold" }, "Totale costi", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "font-bold" }, "Totale ordinato", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TotalizzatoriOdaPerIva, (r, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("p", {
                  class: _normalizeClass([i == 'unknown'? 'text-next-orange': ''])
                }, _toDisplayString(r?.aliquota?.descrizione || "Iva sconosciuta"), 3),
                _createElementVNode("p", {
                  class: _normalizeClass([i == 'unknown'? 'text-next-orange': ''])
                }, _toDisplayString(_ctx.$filters.toCurrency(r?.aliquota?.valore) || "Iva sconosciuta"), 3),
                _createElementVNode("p", {
                  class: _normalizeClass([i == 'unknown'? 'text-next-orange': ''])
                }, _toDisplayString(r?.totale_costi) + " " + _toDisplayString(_ctx.valutaAcquistoLabel), 3),
                _createElementVNode("p", {
                  class: _normalizeClass([i == 'unknown'? 'text-next-orange': ''])
                }, _toDisplayString(r?.totale_costi_euro) + " €", 3)
              ], 64))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_2, [
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "font-bold" }, "Data scadenza", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "font-bold" }, "Tipo effetto", -1)),
            _createElementVNode("p", _hoisted_3, "Valore " + _toDisplayString(_ctx.valutaAcquistoLabel), 1),
            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "font-bold" }, "Valore €", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaPianoPagamento.rows, (c, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$filters.toDate(c.data_scadenza)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.getTipoEffetto(c.tipo_effetto_id)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$filters.toCurrency(c.valore)) + " " + _toDisplayString(_ctx.valutaAcquistoLabel), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$filters.toCurrency(c.valore * (c.conversione))) + " €", 1)
              ], 64))
            }), 256))
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_NextButton, {
                variant: "outline-secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal_oda_visible = false)),
                class: "col-start-3 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode(" Annulla ")
                ])),
                _: 1
              }),
              _createVNode(_component_NextButton, {
                variant: "primary",
                onClick: _ctx.createOda,
                class: "ml-4 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode(" Conferma "),
                  _createElementVNode("i", { class: "spinner" }, null, -1)
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createVNode(_component_ModalRigaPagamento, {
      visible: _ctx.modal_visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modal_visible) = $event)),
      id: _ctx.row_model.id,
      "onUpdate:id": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.row_model.id) = $event)),
      data_scadenza: _ctx.row_model.data_scadenza,
      "onUpdate:data_scadenza": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.row_model.data_scadenza) = $event)),
      tipo_effetto_id: _ctx.row_model.tipo_effetto_id,
      "onUpdate:tipo_effetto_id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.row_model.tipo_effetto_id) = $event)),
      valore: _ctx.row_model.valore,
      "onUpdate:valore": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.row_model.valore) = $event)),
      onSave: _ctx.onSave,
      errors: _ctx.errors,
      loading: _ctx.loading_modal
    }, null, 8, ["visible", "id", "data_scadenza", "tipo_effetto_id", "valore", "onSave", "errors", "loading"]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.fornitore?.id_gamma)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            dismissable: false,
            class: "bg-next-orange drop-shadow-lg mt-3 z-50"
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode(" Il seguente fornitore non ha settato un id Gamma quindi non è possibile generare un ODA ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.canCreateOda)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            dismissable: false,
            class: "bg-next-orange drop-shadow-lg mt-3 z-50"
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode(" L'azienda del gruppo Next scelta nel progetto, non è abilitata a su questo fornitore ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.error_message)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 2,
            dismissable: true,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.error_message = '')),
            class: "bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.error_message), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, " I record del fornitore non sono nella medesima valuta. Impossibile creare l'ordine di acquisto ", 512), [
        [_vShow, !_ctx.StessaValutaAcquisto]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h1", _hoisted_11, [
            _cache[22] || (_cache[22] = _createTextVNode(" Sottoprogetto: ")),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.sottoprogetto?.titolo), 1),
            _cache[23] || (_cache[23] = _createTextVNode(" - Fornitore: ")),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.fornitore.denominazione), 1)
          ]),
          _withDirectives(_createVNode(_component_NextButton, {
            class: "px-10",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modal_oda_visible = true))
          }, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createTextVNode("Crea ODA ")
            ])),
            _: 1
          }, 512), [
            [_vShow, _ctx.StessaValutaAcquisto && _ctx.canCreateOda]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_CardDivisorioGrigio, { class: "col-span-2" }, {
            top: _withCtx(() => _cache[25] || (_cache[25] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Totale costi")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.Totalizzatori.totale_costi.toCurrencyString()) + " " + _toDisplayString(_ctx.valutaAcquistoLabel), 1)
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (i, k) => {
          return (_openBlock(), _createElementBlock("div", { key: k }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, [
                _cache[26] || (_cache[26] = _createTextVNode("Aliquota: ")),
                _createElementVNode("span", null, _toDisplayString(k in _ctx.AliquoteAcquisto ? _ctx.AliquoteAcquisto[k]?.descrizione : 'Sconosciuta'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", null, [
                _cache[27] || (_cache[27] = _createTextVNode("Totale costi: ")),
                _createElementVNode("span", null, _toDisplayString(k in _ctx.TotalizzatoriIva ? _ctx.TotalizzatoriIva[k]?.totale_costi : 'Sconosciuta') + " " + _toDisplayString(_ctx.valutaAcquistoLabel), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_OffertaTable, {
                class: "rotate-x-180 w-full border-separate",
                actionClass: "relative",
                ordered_records: i,
                onOrderUpdate: _ctx.performOrder
              }, null, 8, ["ordered_records", "onOrderUpdate"])
            ])
          ]))
        }), 128)),
        _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "font-bold" }, "Piano di pagamento", -1)),
        _createElementVNode("p", null, "Totale pianificato: " + _toDisplayString(_ctx.TotalePianificato.toCurrencyString()) + " " + _toDisplayString(_ctx.valutaAcquistoLabel), 1),
        _createElementVNode("p", null, "Residuo: " + _toDisplayString((_ctx.Totalizzatori.totale_costi - _ctx.TotalePianificato).toCurrencyString()) + " " + _toDisplayString(_ctx.valutaAcquistoLabel), 1),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 table-fixed w-full border-separate border-spacing-1 py-4",
            cols: _ctx.righeCols,
            "onUpdate:cols": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.righeCols) = $event)),
            rows: _ctx.listaPianoPagamento.rows
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.listaPianoPagamento.rows, (c, j) => {
              return {
                name: `td_${j}_0`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDate(c.data_scadenza)), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoPagamento.rows, (c, j) => {
              return {
                name: `td_${j}_1`,
                fn: _withCtx(({context}) => [
                  _createTextVNode(_toDisplayString(_ctx.getTipoEffetto(context.row[context.cell.prop])), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoPagamento.rows, (c, j) => {
              return {
                name: `td_${j}_2`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(c.valore)), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoPagamento.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(c.valore * (c.conversione))), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoPagamento.rows, (c, j) => {
              return {
                name: `td_${j}_4`,
                fn: _withCtx((context) => [
                  _createVNode(_component_TabellaContextMenu, {
                    menuClass: "shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                    buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                    context: c,
                    id: j,
                    teleport_to: "#modal",
                    cmOpener: _ctx.cmOpener
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.duplicaRiga(c)),
                        class: "w-full hover:text-next-neu mb-2"
                      }, "Duplica", 8, _hoisted_20),
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.modificaRiga(c)),
                        class: "w-full hover:text-next-neu mb-2"
                      }, "Modifica", 8, _hoisted_21),
                      _createVNode(_component_ConfirmDelete, {
                        position: "left",
                        onCancella: ($event: any) => (_ctx.cancellaRiga(c,j))
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createElementVNode("span", { class: "cursor-pointer hover:text-next-neu" }, "Elimina", -1)
                        ])),
                        _: 2
                      }, 1032, ["onCancella"])
                    ]),
                    _: 2
                  }, 1032, ["context", "id", "cmOpener"])
                ])
              }
            })
          ]), 1032, ["cols", "rows"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.StessaValutaAcquisto && _ctx.canCreateOda)
            ? (_openBlock(), _createBlock(_component_NextButton, {
                key: 0,
                variant: "primary",
                onClick: _ctx.addPianoDiPagamento,
                class: "px-3 py-2"
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("Aggiungi riga di pagamento ")
                ])),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}